import HeaderServerName from "./Components/HeaderServerName";
import { BiSolidUserDetail, BiLogOut  } from "react-icons/bi";
import { IoSettingsSharp } from "react-icons/io5";
import { Route, Routes, useNavigate} from 'react-router-dom';
import { FaUserGear } from "react-icons/fa6";
import Dropdown from "../../../../Components/DropdownImg/Dropdown";
import { GetCurrentUser } from "../../../../Services/Authorization/AuthorizationManager";
import "../Header/Header.css";
import { Logout } from "../../../../Services/Api/AuthRequests";
import { Cookies } from "react-cookie";
import { CheckPanelPermissions } from "../../../../Services/Permissions/PermissionManager";
import { Permissions } from "../../../../Services/Permissions/Data/Permissions";

const cookies = new Cookies();

const Header = ({GetServer}) => {
    const navigate = useNavigate();
    const user = GetCurrentUser();

    const logOut = () => {
        const data = GetCurrentUser();

        Logout(data.RefreshTokenId, () => 
        {
            cookies.remove("refreshToken");
            cookies.remove("jwt");
            
            window.location.reload();
        });
    }

    const getAdminButtons = () => {
        const user = GetCurrentUser();

        if(CheckPanelPermissions(Permissions[1], user.Permissions, true))
            return <button onClick={() => navigate("/settings")} className="dropdownLink"><IoSettingsSharp/>Ustawienia Panelu</button>;
    }

    return (
        <header>
            <div className="subpageInfo">
            <Routes>
                <Route path="/" element={
                    <>
                        <span className="currentSubpage">Home Page</span>              
                    </>
                }/>
                <Route path="/settings" element={
                    <>
                        <span className="currentSubpage">Settings</span>              
                    </>
                }/>
                <Route path="/group/:groupId" element={
                    <>
                        <span className="currentSubpage">Group Settings</span>              
                    </>
                }/>
                <Route path="/scpsl-ra/:serverId" element={
                    <>
                        <HeaderServerName GetServer={GetServer}/>
                        <span className="currentSubpage">Remote Admin</span>              
                    </>
                }/>
                <Route path="/scpsl-logs/:serverId" element={
                    <>
                        <HeaderServerName GetServer={GetServer}/>
                        <span className="currentSubpage">Logs</span>              
                    </>
                }/>
                <Route path="/scpsl-punishments/:serverId" element={
                    <>
                        <HeaderServerName GetServer={GetServer}/>
                        <span className="currentSubpage">Punishments</span>              
                    </>
                }/>       
                                                         
            </Routes>
            </div>
            <div className="accountSection center-x">
            <Dropdown
                className="right-0"
                title={user.Login} 
                items={[
                    getAdminButtons(),
                    // <button onClick={() => navigate("/account-settings")} className="dropdownLink"><FaUserGear />Ustawienia konta</button>,
                    // <button onClick={() => navigate("/account-statistics")} className="dropdownLink"><BiSolidUserDetail/>Statystyki konta</button>,
                    <button onClick={() => logOut()} className="dropdownLink"><BiLogOut/>Wyloguj się</button>
                ]}
                img={user.ProfileAvatarURL}
            />
            </div>
      </header>
    );
}

export default Header;